import _defineProperty from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import _variables from "@/styles/variables.scss";
export default {
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(["permission_routes", "sidebar", "menuList"])), mapState({
    slideClass: function slideClass(state) {
      return state.settings.slideClass;
    }
  })), {}, {
    classObj: function classObj() {
      return _defineProperty(_defineProperty({}, this.slideClass, true), "has-logo", this.showLogo);
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  created: function created() {
    //虚拟路由
    /*     this.$set(this.menuList,5, {
          category: "Web",
          enCode: "productInfo",
          fullName: "生产品信息设定",
          children: [
            {
              category: "Web",
              children: null,
              enCode: "FSDFKjkfd",
              fullName: "产品咨询设定",
              urlAddress: "productInfo/consulting",
              path:"/productInfo/consulting",
              hasChildren:false
            },
            {
              category: "Web",
              children: null,
              enCode: "FSDFKjkfcd",
              fullName: "物料分类设定",
              urlAddress: "productInfo/material",
               hasChildren:false,
               
     path:"/productInfo/material"
    }
          ],
          icon: "icon-ym icon-ym-system",
          hasChildren: true,
          isLeft: false,
          path:'/productInfo'
        })
    
        console.log(this.menuList); */
    // console.log(this.menuList);
  }
};